import { NavigateOptions, Path, useNavigate } from 'react-router-dom';
import { checkIsAppPage } from 'tools/loaction';
import { useSelector } from 'react-redux';
import { DEFAULT_HOME_URL } from 'tools/tools';

export const useMiNavigation = () => {
    const navigate = useNavigate();

    const isAppPage = checkIsAppPage();
    if (isAppPage)
        return (newLocation: string | number | Partial<Path>, options?: NavigateOptions) => {
            if (typeof newLocation === 'number') {
                history.go(newLocation);
            } else {
                if (options?.replace) {
                    window.location.replace(String(newLocation));
                } else {
                    window.location.href = String(newLocation);
                }
            }
        };

    return navigate;
};

export const useGetHomeUrl = (): string => {
    const homeUrl = useSelector((state: any) => state.auth?.userInfo?.homeUrl);

    if (homeUrl && homeUrl > '') return homeUrl;

    return DEFAULT_HOME_URL;
};

export const useGetStartPage = (): string => {
    const startPageUrl = useSelector((state: any) => state.auth?.userInfo?.startPageUrl);
    const homeUrl = useGetHomeUrl();

    if (startPageUrl && startPageUrl > '' && startPageUrl != DEFAULT_HOME_URL) {
        return startPageUrl;
    }

    return homeUrl;
};
